"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function TH(props) {
  var className = props.className,
      size = props.size,
      weight = props.weight,
      uppercase = props.uppercase,
      active = props.active,
      children = props.children,
      rest = _objectWithoutProperties(props, ["className", "size", "weight", "uppercase", "active", "children"]);

  var finalWeight = active ? 'semibold' : weight;
  var cName = (0, _classnames.default)(className, "text-".concat(size, " tracking-wide font-").concat(finalWeight), {
    uppercase: uppercase,
    active: active
  });
  return _react.default.createElement("th", _extends({
    valign: "center",
    className: cName
  }, rest), children);
}

TH.propTypes = {
  size: _propTypes.default.oneOf(['xxs-xs', 'xs', 'xs-sm', 'sm', 'sm-base', 'base']),
  weight: _propTypes.default.oneOf(['hairline', 'thin', 'light', 'normal', 'medium', 'semibold', 'bold', 'extrabold', 'black']),
  uppercase: _propTypes.default.bool,
  active: _propTypes.default.bool
};
TH.defaultProps = {
  size: 'sm',
  weight: 'medium',
  uppercase: true,
  active: false
};

var _default = _react.default.memo(TH);

exports.default = _default;